<template>
  <v-app id="inspire" class="bodyPadding regionScreen"> 
    <mo-header></mo-header>
    <v-content>
		<region-head></region-head>		
		<region-list></region-list>
    </v-content>
  </v-app>
</template>

<script>

	import RegionHead from './Header.vue';	
	import RegionList from './List.vue';	
	import { mapGetters } from 'vuex'; 
	
	export default {
		data () {
			return {
		
			}		
		},
		components: {
			RegionHead,		
			RegionList
		},
		computed: {
			...mapGetters([			
				'objAuthorize',
			])
		},
		created() {			
			if( this.objAuthorize.privileges.indexOf('VIEW_REGIONS') === -1 ) {
				this.$router.replace('/');
			}			
		}	
	}
</script>

<style scoped>
	@import '../shared/assets/css/shared.css'
</style>